import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { callApi } from "../../../ApiHelper/ApiHelper";
import { apiUrl } from "../../../ApiHelper/ApiUrl";
import { toast } from "react-toastify";
import CommonTable from "../../../components/comman/CommonTable";
import EditIcon from "../../../components/Icons/EditIcon";
import MainHeading from "../../../components/comman/MainHeading";
import PlusIcon from "../../../components/Icons/PlusIcon";
import AddCustomerCompanyModal from "./AddCustomerCompanyModal";
import BgBlurLoader from "../../../components/Loaders/BgBlurLoader";
import { RoutesLink } from "../../../ApiHelper/RoutesLink";
import CustomersIcon from "../../../components/Icons/CustomersIcon";

export default function CustomerDetail() {
  let { id } = useParams();
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();
  const [customerDetail, setCustomerDetail] = useState({});
  const [modal, setModal] = useState(false);
  const toggle = () => {
    setModal(!modal);
  };
  const [EditData, setEditData] = useState("");

  useEffect(() => {
    GetCustomerDetail();
  }, []);

  const GetCustomerDetail = () => {
    let options = {
      method: "GET",
    };
    let API = apiUrl?.get_customer_detail + `?customerId=${id}`;
    setIsLoading(true);
    callApi(API, options).then((response) => {
      setIsLoading(false);
      if (response?.status === true) {
        setCustomerDetail(response?.data);
      } else {
        toast.error(response?.message);
      }
    });
  };

  const HandleUpdate = (data) => {
    setEditData(data);
    toggle();
  };

  const newData = customerDetail?.customercompanies?.map((item) => ({
    ...item,
    toggleStatus: item?.status,
  }));

  const TableHeading = [
    { value: "companyName", label: "Company Name" },
    { value: "email", label: "Email" },
    { value: "phone", label: "Phone" },
    { value: "gst", label: "GST Number" },
    { value: "address", label: "Address" },
    { value: "toggleStatus", label: "Status" },
  ];

  const ActionData = [
    {
      label: "Edit",
      className: "btn btn-link",
      icon: <EditIcon />,
      title: "edit",
      clickHandler: HandleUpdate,
    },
  ];

  const handleStatusToggle = (data, status) => {
    let submitData = {
      status: status ? 0 : 1,
    };
    const options = {
      method: "POST",
      data: submitData,
    };
    let API = apiUrl?.update_customer_company + `?customerCompanyId=${data?.id}`;
    callApi(API, options).then((response) => {
      if (response?.status === true) {
        toast.success(response?.message);
        GetCustomerDetail();
      } else {
        toast.error(response?.message);
      }
    });
  };

  const totalCompaniesCount = customerDetail?.customercompanies?.length || 0;

  return (
    <>
      {isLoading && <BgBlurLoader />}
      <div className="content container-fluid pb-5">
        {/* Main Header with Edit Customer Action */}
        <MainHeading
          title="Customer Detail"
          showBackButton={true}
          buttonText="Edit Customer"
          buttonIcon={<EditIcon />}
          clickHandler={() =>
            navigate(RoutesLink.add_customer, {
              state: { data: customerDetail },
            })
          }
        />

        {/* Master Summary Card */}
        <div
          className="card border-0 shadow-sm rounded-3 mb-4"
          style={{ background: "#ffffff" }}
        >
          <div className="card-body p-4">
            {/* Top Identity Strip */}
            <div
              className="d-flex align-items-start justify-content-between flex-wrap gap-3 pb-3 border-bottom"
              style={{ borderColor: "#f1f5f9" }}
            >
              <div className="d-flex align-items-center gap-3">
                <div
                  className="d-inline-flex align-items-center justify-content-center rounded-3 p-2.5 flex-shrink-0"
                  style={{
                    background: "#eff6ff",
                    color: "#2563eb",
                    width: "52px",
                    height: "52px",
                    border: "1px solid #bfdbfe",
                  }}
                >
                  <CustomersIcon />
                </div>

                <div>
                  <div className="d-flex align-items-center gap-2 flex-wrap">
                    <h3
                      className="mb-0 fw-bold text-dark"
                      style={{ letterSpacing: "-0.02em", fontSize: "1.35rem" }}
                    >
                      {customerDetail?.name || "--"}
                    </h3>
                    <span
                      className={`badge rounded-pill px-2.5 py-1 fw-semibold ${
                        customerDetail?.status === 0
                          ? "bg-danger-subtle text-danger border border-danger-subtle"
                          : "bg-success-subtle text-success border border-success-subtle"
                      }`}
                      style={{ fontSize: "12px" }}
                    >
                      {customerDetail?.status === 0
                        ? "Inactive Customer"
                        : "Active Customer"}
                    </span>
                  </div>

                  <div className="text-secondary small mt-1 d-flex align-items-center gap-2 flex-wrap">
                    {customerDetail?.email && (
                      <>
                        <span className="d-inline-flex align-items-center gap-1">
                          <span>✉️</span>
                          <span>{customerDetail.email}</span>
                        </span>
                        <span>•</span>
                      </>
                    )}
                    {customerDetail?.phone && (
                      <>
                        <span className="d-inline-flex align-items-center gap-1">
                          <span>📞</span>
                          <span>{customerDetail.phone}</span>
                        </span>
                        <span>•</span>
                      </>
                    )}
                    <span className="d-inline-flex align-items-center gap-1">
                      <span>📍</span>
                      <span className="text-truncate" style={{ maxWidth: "350px" }}>
                        {customerDetail?.address || "Address Not Specified"}
                      </span>
                    </span>
                  </div>
                </div>
              </div>

              {/* Quick Quantitative Stats */}
              <div className="d-flex align-items-center gap-2 flex-wrap">
                <div
                  className="px-3.5 py-2 rounded-2 text-center"
                  style={{
                    background: "#f8fafc",
                    border: "1px solid #e2e8f0",
                    minWidth: "140px",
                  }}
                >
                  <div
                    className="text-secondary text-uppercase"
                    style={{
                      fontSize: "10px",
                      fontWeight: 700,
                      letterSpacing: "0.05em",
                    }}
                  >
                    GSTIN / Tax ID
                  </div>
                  <div
                    className="fw-bold text-dark text-truncate"
                    style={{
                      fontSize: "15px",
                      lineHeight: "1.2",
                      marginTop: "2px",
                      letterSpacing: "0.02em",
                    }}
                    title={customerDetail?.gstNumber}
                  >
                    {customerDetail?.gstNumber || "--"}
                  </div>
                </div>

                <div
                  className="px-3.5 py-2 rounded-2 text-center"
                  style={{
                    background: "#f8fafc",
                    border: "1px solid #e2e8f0",
                    minWidth: "120px",
                  }}
                >
                  <div
                    className="text-secondary text-uppercase"
                    style={{
                      fontSize: "10px",
                      fontWeight: 700,
                      letterSpacing: "0.05em",
                    }}
                  >
                    Companies
                  </div>
                  <div
                    className="fw-bold text-primary"
                    style={{
                      fontSize: "16px",
                      lineHeight: "1.2",
                      marginTop: "2px",
                    }}
                  >
                    {totalCompaniesCount}
                  </div>
                </div>
              </div>
            </div>

            {/* Key Information Grid */}
            <div className="row g-3 pt-3">
              <div className="col-12 col-sm-6 col-lg-3">
                <div
                  className="p-3 rounded-2 h-100"
                  style={{
                    background: "#f8fafc",
                    border: "1px solid #f1f5f9",
                  }}
                >
                  <div
                    className="text-muted text-uppercase mb-1"
                    style={{
                      fontSize: "11px",
                      fontWeight: 700,
                      letterSpacing: "0.05em",
                    }}
                  >
                    Customer / Firm Name
                  </div>
                  <div
                    className="fw-semibold text-dark text-truncate"
                    title={customerDetail?.name}
                    style={{ fontSize: "13.5px" }}
                  >
                    {customerDetail?.name || "--"}
                  </div>
                  <div
                    className="text-secondary small mt-0.5"
                    style={{ fontSize: "11px" }}
                  >
                    Primary Account Holder
                  </div>
                </div>
              </div>

              <div className="col-12 col-sm-6 col-lg-3">
                <div
                  className="p-3 rounded-2 h-100"
                  style={{
                    background: "#f8fafc",
                    border: "1px solid #f1f5f9",
                  }}
                >
                  <div
                    className="text-muted text-uppercase mb-1"
                    style={{
                      fontSize: "11px",
                      fontWeight: 700,
                      letterSpacing: "0.05em",
                    }}
                  >
                    Email Address
                  </div>
                  <div
                    className="fw-semibold text-dark text-truncate"
                    title={customerDetail?.email}
                    style={{ fontSize: "13.5px" }}
                  >
                    {customerDetail?.email || "--"}
                  </div>
                  <div
                    className="text-secondary small mt-0.5"
                    style={{ fontSize: "11px" }}
                  >
                    Official Correspondence
                  </div>
                </div>
              </div>

              <div className="col-12 col-sm-6 col-lg-3">
                <div
                  className="p-3 rounded-2 h-100"
                  style={{
                    background: "#f8fafc",
                    border: "1px solid #f1f5f9",
                  }}
                >
                  <div
                    className="text-muted text-uppercase mb-1"
                    style={{
                      fontSize: "11px",
                      fontWeight: 700,
                      letterSpacing: "0.05em",
                    }}
                  >
                    Contact Phone
                  </div>
                  <div
                    className="fw-semibold text-dark text-truncate"
                    title={customerDetail?.phone}
                    style={{ fontSize: "13.5px" }}
                  >
                    {customerDetail?.phone || "--"}
                  </div>
                  <div
                    className="text-secondary small mt-0.5"
                    style={{ fontSize: "11px" }}
                  >
                    Primary Contact Number
                  </div>
                </div>
              </div>

              <div className="col-12 col-sm-6 col-lg-3">
                <div
                  className="p-3 rounded-2 h-100"
                  style={{
                    background: "#f8fafc",
                    border: "1px solid #f1f5f9",
                  }}
                >
                  <div
                    className="text-muted text-uppercase mb-1"
                    style={{
                      fontSize: "11px",
                      fontWeight: 700,
                      letterSpacing: "0.05em",
                    }}
                  >
                    GSTIN
                  </div>
                  <div
                    className="fw-semibold text-dark text-truncate"
                    title={customerDetail?.gstNumber}
                    style={{ fontSize: "13.5px" }}
                  >
                    {customerDetail?.gstNumber || "--"}
                  </div>
                  <div
                    className="text-secondary small mt-0.5"
                    style={{ fontSize: "11px" }}
                  >
                    Tax Identification
                  </div>
                </div>
              </div>

              {/* Registered Address */}
              <div className="col-12">
                <div
                  className="p-3 rounded-2"
                  style={{
                    background: "#f8fafc",
                    border: "1px solid #f1f5f9",
                  }}
                >
                  <div
                    className="d-flex align-items-center gap-1.5 text-muted text-uppercase mb-1"
                    style={{
                      fontSize: "11px",
                      fontWeight: 700,
                      letterSpacing: "0.05em",
                    }}
                  >
                    <span>📍</span>
                    <span>Registered Business Address</span>
                  </div>
                  <div
                    className="fw-semibold text-dark"
                    style={{ fontSize: "13.5px", lineHeight: "1.5" }}
                  >
                    {customerDetail?.address || "--"}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Associated Customer Companies Card */}
        <div
          className="card border-0 shadow-sm rounded-3 mb-4 overflow-hidden"
          style={{ background: "#ffffff" }}
        >
          <div
            className="card-header bg-white py-3 px-4 d-flex align-items-center justify-content-between flex-wrap gap-2 border-bottom"
            style={{ borderColor: "#f1f5f9" }}
          >
            <div className="d-flex align-items-center gap-2.5">
              <div
                className="rounded-2 p-1.5 d-flex align-items-center justify-content-center"
                style={{
                  background: "#f1f5f9",
                  color: "#475569",
                  width: "36px",
                  height: "36px",
                  fontSize: "18px",
                }}
              >
                🏛️
              </div>
              <div>
                <div className="d-flex align-items-center gap-2">
                  <h5
                    className="mb-0 fw-bold text-dark"
                    style={{ fontSize: "15px" }}
                  >
                    Customer Companies
                  </h5>
                  <span
                    className="badge rounded-pill bg-light text-secondary border px-2.5 py-1"
                    style={{ fontSize: "11px", fontWeight: 600 }}
                  >
                    {totalCompaniesCount} {totalCompaniesCount === 1 ? "Entity" : "Entities"}
                  </span>
                </div>
                <span
                  className="text-secondary small d-none d-sm-inline"
                  style={{ fontSize: "11.5px" }}
                >
                  Corporate branches and billing accounts associated with this customer
                </span>
              </div>
            </div>

            <button
              type="button"
              className="btn btn-primary d-inline-flex align-items-center gap-1.5 px-3 py-2 rounded-2 fw-semibold"
              style={{ fontSize: "13px" }}
              onClick={() => {
                setEditData("");
                toggle();
              }}
            >
              <PlusIcon />
              <span>Add Company</span>
            </button>
          </div>

          <div className="card-body p-0">
            <CommonTable
              TableHeading={TableHeading}
              TableData={newData}
              ActionData={ActionData}
              handleStatusToggle={handleStatusToggle}
            />
          </div>
        </div>
      </div>

      <AddCustomerCompanyModal
        modal={modal}
        toggle={toggle}
        customerId={id}
        GetCustomerCompanyList={GetCustomerDetail}
        modalData={EditData}
      />
    </>
  );
}
